import { checkElementInView } from './checkElementInView';

const primarySectionSelectors = '#page > .content-wrapper > *';
const primarySections = document.querySelectorAll(primarySectionSelectors);
const secondarySectionSelectors =
	'#page > .content-wrapper > * > *:not(.lightbox):not(.no-animation), #page .content-wrapper .content-wrapper > *:not(.lightbox):not(.no-animation), .animate-in';
const secondarySections = document.querySelectorAll(secondarySectionSelectors);

const header = document.querySelector('.main-header');
const top = document.getElementById('top');

let observer1;
let observer2;
// eslint-disable-next-line no-unused-vars
let observer3;

const sectionsInView = () => {
	if (header && primarySections.length) {
		// eslint-disable-next-line no-undef
		observer1 = checkElementInView(
			primarySectionSelectors,
			primarySectionInView,
			sectionOut,
			{
				root: null,
				rootMargin: `0px 0px -${window.innerHeight - 68}px 0px`,
				threshold: [0],
			}
		);
	}

	if (secondarySections.length) {
		observer2 = checkElementInView(
			secondarySectionSelectors,
			secondarySectionInView,
			sectionOut,
			{
				root: null,
				rootMargin: '0px 0px -20% 0px',
				threshold: [0],
			}
		);
	}

	if (top) {
		observer3 = checkElementInView(top, topSectionInView, topSectionOut, {
			root: null,
			rootMargin: '0px 0px 0px 0px',
			threshold: [0],
		});
	}
};

const primarySectionInView = (e) => {
	if (
		e.hasAttribute('data-bg') &&
		!document.body.classList.contains('smoothScrolling')
	) {
		//setHeaderColors(e);
	}
};

const sectionOut = () => {};

const secondarySectionInView = (e) => {
	e.classList.add('in-viewport');
};

// eslint-disable-next-line no-unused-vars
const topSectionInView = (e) => {
	//setHeaderColors('transparent');
	if (!document.body.classList.contains('menu-opened')) {
		document.body.classList.add('topSectionInView');
		document.body.classList.remove('topSectionOutOfView');
		document.body.classList.remove('alertOutOfView');
	}
};

// eslint-disable-next-line no-unused-vars
const topSectionOut = (e) => {
	//setHeaderColors('black');
	document.body.classList.remove('topSectionInView');
	document.body.classList.add('topSectionOutOfView');
	document.body.classList.add('alertOutOfView');
};

// JavaScript to remove class from body on hover
// Get all elements with the class name 'block-navigation'
const navigationBlocks = document.getElementsByClassName('block-navigation');

// Loop through each element and add event listeners
for (let i = 0; i < navigationBlocks.length; i++) {
	navigationBlocks[i].addEventListener('click', function () {
		document.body.classList.remove('topSectionInView');
		document.body.classList.add('topSectionOutOfView');
	});
}

const resetObservers = () => {
	if ('object' === typeof observer1) {
		observer1.disconnect();
	}

	if ('object' === typeof observer2) {
		observer2.disconnect();
	}

	sectionsInView();
};

export { sectionsInView, resetObservers };
